import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IRefundEvents } from '../../api/interfaces'
import { IChart } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

async function getRefundEventsConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_refund_event_count', timeframe)) as IRefundEvents[]
	const series1 = chartData.map((element: IRefundEvents) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.REFUND_COUNT }
	})
	const series2 = chartData.map((element: IRefundEvents) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.REFUND_COUNT_CUMULATIVE }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'refund event count',
			type: 'bars',
			seriesGroup: '[event #]',
			color: 'green'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: 'refund event count cumulative',
			type: 'line',
			seriesGroup: ' [event #]',
			color: 'orange'
		}
	]
	return { config: config, latestValue: 0, latestValueDate: 0 }
}
const RefundEvents = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getRefundEventsConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Refund Events Count"
			chartDesc="Number of swap refund events. These typically occur when the actual output is below the minimum limit set by the user."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="12a94956-cd79-4e31-b38b-daef72b01c38"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			reverseLegend={true}
		/>
	)
}

export default RefundEvents
